import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {AzoraSelect} from './select';
import {AzoraListModule} from '@azora/core';
import {OverlayModule} from '@angular/cdk/overlay';
import {ScrollingModule} from "@angular/cdk/scrolling";

const COMPONENT = [AzoraSelect];

@NgModule({
    imports: [
        CommonModule,
        AzoraListModule,
        OverlayModule,
        ScrollingModule
    ],
    declarations: COMPONENT,
    exports: COMPONENT,
    entryComponents: COMPONENT
})
export class AzoraSelectModule {
}
